module.exports = __webpack_public_path__ + "static/img/WechatIMG14.27d60a37.jpeg";